import { ProductCard } from '../_rcpo/ProductCard'
import { ProductCardLoading } from '../_rcpo/ProductCardLoading'
import Indicators from '@components/_rolex/sliders/Indicators'
import { breakpoints, Track, useSlider } from '@components/gassan-ui'
import { Button } from '@components/rolex-ui/Button'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { useTranslation } from 'next-i18next'
import { FC, Fragment, useMemo, useRef } from 'react'
import _chunk from 'lodash.chunk'
import { RolexContainer } from '@components/_rolex/Container'
import { useRCPOData } from './ProductOverview/hooks/use-rcpo-data'
import { getLocalePrefix } from '@lib/get-locale-prefix'

type RCPOLatestWatchesProps = {
  buttonTitle: string
}

export const RCPOLatestWatches: FC<RCPOLatestWatchesProps> = ({ buttonTitle }) => {
  const trackRef = useRef<HTMLDivElement>(null)
  const { onTouchEnd, index, goToIndex } = useSlider({
    trackRef,
  })
  const {
    t,
    i18n: { language },
  } = useTranslation('navigation')
  const { items, fetching } = useRCPOData({ limit: 4 })

  const localizedHref = `${getLocalePrefix(language)}${t(`rcpo.selection.url`, {
    ns: 'navigation',
  })}`

  const isTabletUp = useBreakpoint(breakpoints.small)

  const chunks = useMemo(() => {
    if (items) {
      return _chunk(items, isTabletUp ? 3 : 2)
    }
    return _chunk(Array(6).fill(null), isTabletUp ? 3 : 2)
  }, [isTabletUp, items])

  return (
    <RolexContainer className="flex !w-full flex-col items-center lg:gap-10">
      <div className="hidden w-full grid-cols-6 gap-2 lg:grid lg:grid-cols-12">
        {fetching || !items ? (
          <>
            <ProductCardLoading />
            <ProductCardLoading />
            <ProductCardLoading />
            <ProductCardLoading />
          </>
        ) : (
          items.map((item: any) => <ProductCard key={item.id} data={item} />)
        )}
      </div>
      <div className="block lg:hidden">
        <Track ref={trackRef} onTouchEnd={onTouchEnd}>
          {chunks.map((chunk, key) => (
            <Fragment key={key}>
              <div className="mr-4 grid min-w-full snap-start grid-cols-2 gap-x-4 sm:grid-cols-3">
                {chunk.map((item, key) => (
                  <div className="group w-full" key={key}>
                    {items ? <ProductCard data={item} /> : <ProductCardLoading />}
                  </div>
                ))}
              </div>
            </Fragment>
          ))}
        </Track>
        <Indicators
          activeIndex={index}
          variant="animated"
          count={chunks.length}
          onChangeIndex={goToIndex}
        />
      </div>
      <Button
        as="link"
        href={localizedHref}
        variant="primary"
        className="w-fit focus:outline-none focus:ring-2 focus:ring-rolexGreenAlt"
      >
        {buttonTitle}
      </Button>
    </RolexContainer>
  )
}
